import { NgModule } from '@angular/core';
import { BrandCrosscheckAllComponent } from './brand-crosscheck-all.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const routes = [
  {
      path     : 'brand-crosscheck-all',
      component: BrandCrosscheckAllComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    NgxChartsModule
  ],
  declarations: [
    BrandCrosscheckAllComponent
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ]
})

export class BrandCrosscheckAllModule { }
